import React from 'react';
import { ArrowRight as ArrowRightIcon, Leaf as LeafIcon, LockKeyhole as LockKeyholeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-forest px-5 pt-20 text-cream sm:pt-24 lg:px-8" data-id="element-35" data-mp="3ghc508vl1fre">
      <div className="mx-auto max-w-4xl text-center" data-id="element-36" data-mp="32pffmclatjyp">
        <LeafIcon size={30} className="mx-auto text-sage" data-id="element-37" data-mp="36p6bgupomqa3" />
        <h2 className="mt-5 font-serif text-4xl leading-tight sm:text-5xl" data-id="element-38" data-mp="36ppn5toqoifo">
          Your best mornings aren&apos;t behind you.
          <span className="block" data-id="element-39" data-mp="38qyt7e9m7ve">They&apos;re 21 days away.</span>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-8 text-cream/75" data-id="element-40" data-mp="36mr0ed8wopu">
          After 50, your body deserves food that actually supports it. One small
          change at breakfast can shift your energy, your weight, and how you
          feel every single day. You deserve to find out what that feels like.
        </p>
        <a id="final-purchase" href="https://pay.hotmart.com/Q106802782G?checkoutMode=10" className="mt-8 inline-flex w-full items-center justify-center gap-3 rounded-full bg-terracotta px-8 py-5 text-base font-extrabold tracking-wide text-white shadow-lg shadow-black/30 transition hover:bg-[#c16048] focus:outline-none focus:ring-4 focus:ring-cream/35 sm:w-auto" data-id="element-41" data-mp="2ey05vyr700df">
          CLAIM MY COMPLETE GUIDE — $19.97 <ArrowRightIcon size={20} data-id="element-42" data-mp="3q7txtekag7uo" />
        </a>
        <p className="mt-4 flex justify-center gap-2 text-sm font-semibold text-cream/75" data-id="element-43" data-mp="830gdarw9qws">
          <LockKeyholeIcon size={14} data-id="element-44" data-mp="33xe1y3atysi" /> Secure checkout · 7-day guarantee ·
          Instant access
        </p>
      </div>
      <div className="mx-auto mt-16 max-w-6xl border-t border-cream/15 py-8 text-center text-xs leading-6 text-cream/55" data-id="element-45" data-mp="htczqznz3e1c">
        <p data-id="element-46" data-mp="cus3tcfr7gip">© 2026 Edad Radiante · All rights reserved</p>
        <nav className="mt-2 flex justify-center gap-4" aria-label="Legal" data-id="element-47" data-mp="qthzcnmxd84y">
          <a href="#privacy" className="underline underline-offset-2" data-id="element-48" data-mp="qrfaw81f7n2c">
            Privacy Policy
          </a>
          <a href="#terms" className="underline underline-offset-2" data-id="element-49" data-mp="mq3jpy2wets1">
            Terms of Use
          </a>
          <a href="#contact" className="underline underline-offset-2" data-id="element-50" data-mp="yu7hysrlhryq">
            Contact
          </a>
        </nav>
        <p className="mx-auto mt-6 max-w-4xl" data-id="element-51" data-mp="13sr2qpugcxpi">
          This product is a digital recipe guide. Results may vary between
          individuals. The information contained in this guide is for
          educational and informational purposes only and does not constitute
          medical advice. Always consult your healthcare provider before making
          significant dietary changes.
        </p>
      </div>
    </footer>;
}